import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { getMutationAllIntegrationsUpdater } from '../../graphql/allIntegrations';
import { INSTALLABLE_PLATFORM_INFO_MAP } from '../../integrations/IntegrationPlatformInfo';
import UIActions from '../../ui/UIActions';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';

const DELETE_INTEGRATION_MUTATION = gql(`
  mutation deleteIntegration($platform: String!) {
    deleteIntegration(platform: $platform) {
      id
    }
  }
`);

const useDeleteIntegration = () => {
  const dispatch = useAppDispatch();
  const [mutate, result] = useMutation(DELETE_INTEGRATION_MUTATION, {
    update: getMutationAllIntegrationsUpdater('deleteIntegration', false),
  });

  const deleteIntegration = useCallback(
    (platform: string) => {
      const platformInfo = INSTALLABLE_PLATFORM_INFO_MAP[platform];
      if (!platformInfo) {
        return;
      }
      const { name } = platformInfo;

      dispatch(
        UIActions.confirmModal({
          title: 'Remove Integration?',
          message: `Are you sure you want to remove the integration with ${name}?`,
          onConfirm: () => {
            mutate({ variables: { platform } }).then(() => {
              dispatch(
                UIActions.pushToast({
                  level: 'success',
                  message: `${name} integration removed`,
                }),
              );
            });
          },
        }),
      );
    },
    [dispatch, mutate],
  );

  return [deleteIntegration, result] as const;
};

export default useDeleteIntegration;
